<template>
	<div class="at-sidebarhead" :class="{'at-overlay' : openSetting }">
		<img :src="thumbnailImg ? thumbnailImg : defaultAvatar " :alt="userProfileData.userName" />
		<h2>{{textCapitalize(userProfileData.userName)}}</h2>
		<div class="at-sidebarhead_menu">
			<a href="javascript:void(0);"><i class="guppy-more-horizontal"></i></a>
			<ul class="at-uploadoption">
				<li v-if="groupChatEnable && createGroup">
					<a href="javascript:void(0);" 
						@click.prevent="createGroupMember()"
						guppy-data-target="#creategroup">
						<i class="guppy-users"></i>
						{{TRANS.create_group_txt }}
					</a>
				</li>
          		<li>
					<a href="javascript:void(0);" @click.prevent="toggleSidebar()"><i class="guppy-settings"></i> {{TRANS.settings}}</a>
				</li>
			</ul>
		</div>
		<a href="javascript:void(0);" class="at-closechat" v-if="isWidgetChat" @click.prevent="showWidget()" ><i class="guppy-x"></i></a>
		<div class="at-chat_sidebarsetting" :class="{'at-chat_profilesettingopen' : openSetting }">
			<div class="at-chat_sidebarsettingtitle">
				<h2>{{TRANS.profile_settings}}</h2>
				<a href="javascript:void(0);" @click.prevent="toggleSidebar()"><i class="guppy-x"></i></a>
			</div>
			<div class="at-chat_sidebarsettingarea">
				<div class="at-chat_sidebarsettingcontent">
					<div class="at-chat_mutenotify" :class="{'at-disabled' : notificationLoader }">
						<input type="checkbox" @click.prevent="muteNotification()" :checked="userProfileData.muteNotification" id="mute">
						<label for="mute">
							<span>{{TRANS.mute}}</span>
							<i class="guppy-volume-2"></i>
						</label>
					</div>
				</div>
				<div class="at-guppylogout">
					<a :href="logoutUrl"><i class="guppy-power"></i>{{TRANS.logout}}</a>
				</div>
				<div v-if="isAllowEditAccSetting" class="at-chat_sidebarsettingcontent">
					<h4>{{TRANS.settings}}</h4>
					<form class="at-themeform" enctype='multipart/form-data'>
						<fieldset>
							<div class="at-form-group-wrap">
								<div class="at-form-group">
									<label class="at-formtitle at-important">{{TRANS.full_name}}</label>
									<input type="text" required class="at-form-control" :placeholder="TRANS.your_name" v-model="profileInfo.userName">
								</div>
								<div class="at-form-group">
									<label class="at-formtitle at-important">{{TRANS.email}}</label>
									<input type="email" required class="at-form-control" :placeholder="TRANS.your_email" v-model="profileInfo.userEmail">
								</div>
								<div class="at-form-group">
									<label class="at-formtitle at-important">{{TRANS.phone}}</label>
									<input type="text" class="at-form-control" required :placeholder="TRANS.your_phone" v-model="profileInfo.userPhone">
								</div>
								<div class="at-form-group">
									<div class="at-dropbox">
										<div class="at-viewuploadimg" v-show="showImage">
											<img v-if="uploadImage" :src="uploadImage" />
											<a href="javascript:void(0);" @click.prevent="removeImage()" class="at-removeuploadimg">{{TRANS.remove}}</a>
										</div>
										<input type="file" :accept="uploadImgExt.join(',')" id="dropbox" name="dropbox" @change.prevent="onImageUpload">
										<label for="dropbox">
											<span>{{TRANS.click_here}}</span> {{TRANS.upload_photo}}
										</label>
									</div>
								</div>
								<div class="at-form-group">
									<ul class="at-btnlist">
										<li>
											<button :disabled="isloadingUpdt" :class="{'at-disable-btn' : isloadingUpdt }" class="at-btn" @click.prevent="updateProfileInfo()">
												{{TRANS.save_changes}}
											</button>
										</li>
									</ul>
								</div>
							</div>
						</fieldset>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { GUPPYCHAT_CONSTANTS, GUPPYCHAT_SETTINGS, GUPPYCHAT_LOGOUT } from "../../../resources/constants";
	import GuppyChatManager from "../../../resources/controller";
	import RestApiManager from "../../../resources/RestApiController";
	import { mapState } from "vuex";
	export default {
		name : "GuppyChatHeader",
		props : {
			isWidgetChat : {
				type : Boolean,
				required : false,
				default : false
			}
		},
		data(){
			return {
				defaultAvatar : GUPPYCHAT_CONSTANTS.AVATAR,
				logoutUrl : GUPPYCHAT_LOGOUT,
				openSetting : false,
				profileInfo : {
					muteNotification : '',
					userAvatar 	:'' ,
					userEmail  	:'' ,
					userId 		:'' ,
					userName 	:'' ,
					userPhone 	:'' ,
				},
				removeAvatar 	: 0,
				notificationLoader : false, 
				uploadImgExt    : GUPPYCHAT_SETTINGS.imgExt,
				groupChatEnable	: GUPPYCHAT_SETTINGS.groupChatEnable,
				createGroup		: GUPPYCHAT_SETTINGS.createGroup,
				uploadImage 	: '',
				thumbnailImg 	: '',
				file 			: '',
				showImage 		: true,
				isloadingUpdt 	: false,
				getUserIfno 	: true,
				groupMembers 	: '',
			}
		},
		computed :{
			isAllowEditAccSetting(){
				return !GUPPYCHAT_SETTINGS.hideAccSettings
			},
			...mapState({
				userProfileData: state => state.userProfile,
				groupMemberFlag: state => state.groupMemberFlag,
			}),
		},
		methods:{
			showWidget(){
				this.$root.$emit('showWidget');
			},
			textCapitalize(text){
				return GuppyChatManager.usFirst(text);
			},
			createGroupMember(){
				GuppyChatManager.updateGroupMembers();
			},
			toggleSidebar(){
				if( !this.isLoading ) {
					this.openSetting = this.openSetting ? false : true;
				}
			},
			async muteNotification(){
				let data = {
					muteType : 1,
					userId : this.userId,
					chatType : '',
					chatId : ''
				}
				this.notificationLoader = true;
				let response = await RestApiManager.muteNotification(data);
				this.notificationLoader = false;
				if( response.data.type == 'error'){
					this.alertBox('error', this.TRANS.error_title, response.data.desc)
				}
			},
			getProfileInfo(){
				this.isLoading = true;
				this.axios.get('load-profile-info?userId='+this.userId).then( response =>{
					this.isLoading = false;
					if(response.data.type == 'success'){
						let data = response.data.userInfo;
						let info = this.profileInfo;
							info.muteNotification 	= data.muteNotification;
							info.userAvatar 		= data.userAvatar;
							info.userEmail 			= data.userEmail;
							info.userId 			= data.userId;
							info.userName 			= data.userName;
							info.userPhone 			= data.userPhone;
						this.uploadImage = this.thumbnailImg = data.userAvatar;
						this.showImage   = data.userAvatar ? true : false; 
						this.$store.dispatch('getUserProfile', data);
					}
				}).catch( errors =>{
					this.isLoading = false;
					this.errors = errors;
					console.log(errors)
				});
			},
			updateProfileInfo(){
				let dataVal = this.profileInfo;
				let validEmail = GuppyChatManager.validateEmail(dataVal.userEmail);
				if(dataVal.userEmail && dataVal.userName && dataVal.userPhone && validEmail){
					let data = new FormData();
					Object.keys(this.profileInfo).map(item =>{
						data.append(item, this.profileInfo[item]);
					});
					data.append('removeAvatar' , this.removeAvatar);
					if( this.file ){
						data.append(0, this.file);
					}
					this.isloadingUpdt = true;
					this.axios.post('update-profile-info', data).then( response =>{
						this.isloadingUpdt = false;
						if( response.data.type == 'success' ){
							let data = response.data.userInfo;
							this.profileInfo.userEmail = data.userEmail;
							this.profileInfo.userPhone = data.userPhone;
							this.profileInfo.userName  = data.userName;
							if( data.userAvatar ){
								this.profileInfo.userAvatar    = data.userAvatar;
								this.uploadImage = this.thumbnailImg = data.userAvatar;
							} else if( this.removeAvatar == 1){
								this.thumbnailImg = '';
								this.profileInfo.userAvatar = ''
							}
							data['userAvatar'] = this.profileInfo.userAvatar;
							this.$store.dispatch('getUserProfile', data);
						}
					}).catch( errors =>{
						this.isloadingUpdt = false;
						this.errors = errors;
						console.log(errors)
					});
				} else {
					this.alertBox('error', this.TRANS.error_title, this.TRANS.empty_input_err_txt );
				}
			},
			onImageUpload(e){
				let file	= e.target.files[0];
				let fileExt = file.name.split('.').pop();
				 if( this.uploadImgExt.includes('.'+fileExt) ){
					this.removeAvatar 	= 0;
					this.showImage 		= true;
					this.$root.$emit('croppedProfileImage', file)
				 } else {
					this.alertBox('error', this.TRANS.error_title, this.TRANS.invalid_input_file);
            		return;
				}
				e.target.value = ''
			},
			removeImage(){
				this.removeAvatar = 1;
				this.showImage 	 = false;
				this.uploadImage = '';
				this.file		 = '';
				this.profileInfo.userAvatar = ''
			},
		},  
		created(){
			this.getProfileInfo();
		},
		mounted(){
			this.$root.$on('CroppedfileParams', (data)=>{
				this.file 		 = data.file;
				this.uploadImage = data.imageUrl;
			})
		},
	};
</script>

<style>
.mCSB_inside>.mCSB_container{margin: 0;}
.at-sidebarhead {
	z-index: 2;
	padding: 20px;
	background-color: var(--secguppycolor);
	display: flex;
	align-items: center;
	position: relative;
}
.at-sidebarhead > img {
	margin-right: 10px;
	border-radius: 50% !important;
	width: 50px;
	height: 50px;
}
.at-sidebarhead > h2 {
	color: #fff !important;
	letter-spacing: 0.5px;
	font-size: 22px;
	margin: 0;
	line-height: 30px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.at-sidebarhead_menu{
	margin-left: auto;
	position: relative;
	display: inline-flex;
	padding-left: 20px;
}
.at-sidebarhead_menu > a {
	color: #fff;
	font-size: 28px;
	display: inline-block;
	text-decoration: none !important;
}
.at-sidebarhead_menu .at-uploadoption {
	bottom: auto;
    top: 100%;
    right: 0;
}
.at-sidebarhead>a:hover{color: #fff;}
.at-overlay::before {
  content: "";
  position: absolute;
  top: 90px;
  left: 0;
  width: 100%;
  height: calc(100vh + 90px);
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}
.at-dropbox {
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 30px 10px;
	text-align: center;
	width: 100%;
	border: 1.5px dashed #DDDDDD;
	border-radius: 20px;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}
.at-dropbox input {
	display: none;
}
.at-dropbox label {
	margin: 0;
	font: 500 14px/24px var(--primchatfont);
	letter-spacing: 0.5px;
	color: var(--secguppycolor);
	max-width: 180px;
	cursor: copy;
}
.at-dropbox label span {
	color: #3C57E5;
}

.at-dropboxempty {
	border: 0;
	margin-top: 10px;
	min-height: 194px;
}
.at-dropboxempty i {
	padding: 0;
	color: #ddd;
	font-size: 38px;
	margin: 0 0 10px;
	background-color: transparent;
}
.at-dropboxempty label {
	font-size: 15px;
	line-height: 24px;
	color: var(--terguppycolor);
	max-width: initial;
	cursor: initial;
	font-weight: 700;
}
.at-viewuploadimg{
	margin: -20px 0 10px;
	width: 100%;
	position: relative;
	overflow: hidden;
	border-radius: 10px;
	background: #F7F7F7;
	display: flex;
	flex-wrap: wrap;
	min-height: 212px;
	align-items: center;
	justify-content: center;
}
.at-viewuploadimg img{
	width: auto;
	max-width: 100%;
	max-height: 300px;
	border-radius: 5px;
}
.at-removeuploadimg{
	line-height: 20px;
	background: #EF4444;
	border-radius: 0px 0px 10px 10px;
	padding: 10px 20px;
	letter-spacing: 0.5px;
	display: block;
	text-align: center;
	color: #FFFFFF;
	font-size: 16px;
	font-family: var(--primchatfont);
	font-weight: 700;
	border-radius: 0 0 10px 10px;
	position: absolute;
	left: 0;
	bottom: 0;
	min-width: initial;
	width: 100%;
	transition: all 300ms ease-in-out;
	text-decoration: none !important;
}
.at-removeuploadimg:focus,
.at-removeuploadimg:hover{color: #fff;}
.at-chat .at-removeuploadimg:focus{
	background: #EF4444 !important;
}
.at-chat_sidebarsettingtitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 30px;
  border-bottom: 1px solid rgba(221, 221, 221, 0.7);
}
.at-chat_sidebarsettingtitle h2 {
  margin: 0;
  font-size: 24px;
  line-height: 38px;
  letter-spacing: 0.5px;
}
.at-chat_sidebarsettingtitle > a {
  margin: 0 -4px 0 16px;
  font-size: 28px;
  color: var(--secguppycolor);
  display: inline-flex;
  text-decoration: none;
}
.at-chat_sidebarsettingtitle>a:hover{color: var(--secguppycolor);}
.at-sidebarhead .at-chat_sidebarsetting {
  position: absolute;
  right: auto;
  left: 0;
  top: 100%;
  z-index: 10;
  transform: translateX(-100%);
}
.at-sidebarhead .at-chat_profilesettingopen {
  transform: translateX(0);
}
.at-sidebarhead .at-chat_sidebarsettingarea {
  height: calc(100vh - 213px);
}
.at-chat_mutenotify {
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.at-chat_mutenotify.at-disabled{
	background: transparent;
	opacity: 0.5;
}
.at-chat_mutenotify input {
  display: none;
}
.at-chat_mutenotify input:checked + label {
  color: var(--terguppycolor);
}
.at-chat_mutenotify input:checked + label i {
  background-color: #F7F7F7;
  color: var(--terguppycolor);
}
.at-chat_mutenotify input:checked + label i::before {
  content: "";
}
.at-chat_mutenotify input + label {
  align-items: center;
  font: 700 16px/26px var(--primchatfont);
  letter-spacing: 0.5px;
  color: var(--secguppycolor);
  width: 100%;
  cursor: pointer;
  margin: 0 !important;
  display: -ms-flexbox;
  display: flex !important;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 !important;
}
.at-chat_mutenotify label span {
  align-items: center;
  flex: auto;
  height: 48px;
  padding-right: 20px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.at-chat_mutenotify label i {
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex: none;
  border-radius: 3px;
  background-color: var(--primguppycolor);
  font-size: 27px;
  color: #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.at-guppylogout{
	display: flex;
	align-items: center;
	padding: 26px 30px;
	width: 100%;
	border-top: 1px solid #ddd;
}
.at-guppylogout a{
	display: inline-flex;
	color: #EF4444 !important;
	outline: none !important;
	box-shadow: none !important;
	background: transparent !important;
	letter-spacing: 0.5px;
	align-items: center;
	font: 700 16px/26px var(--primchatfont);
}
.at-guppylogout a i{
	font-size: 22px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
}
.at-cropping-popup .at-modaldialog{
	max-width: 700px;
}
</style>